import { getDomainLookup } from "../../../../store/root.selectors";

export const getNode = (state) => getDomainLookup(state).searchUrl;
export const getErrorMessage = (state) => getDomainLookup(state).errorMessage;
export const getTableData = (state) => getDomainLookup(state).tableData;
